import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'bankTransform'
})
export class BankTransformPipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): unknown {
    value?.map(item => {
      item.partnerType = 'I';
      item.eik = item.value || item.eik ;
      item.companyName = item.label || item.companyName || item.sBankName;
      delete item.value;
      delete item.label;
    });
    return value;
  }

}
